module.exports = __webpack_public_path__ + "media/bootstrap-icons/caret-up-square-fill-f09918e0.svg";